import React, { Fragment } from 'react';
import { Trash2 } from 'react-feather';
import { SURVEY_ANSWERS_TYPE, SURVEY_ANSWERS_TYPE_TEXT } from '../../../utils/enums';
import Switch from '../../../components/common/switch/switch';

const Survey = ({item, handleChange, removeItem }) => {

    return (
        <div className="flex">
            <div className="field-filter-item">
                <label className="label-filter">Pergunta</label>
                <br/>                
                <textarea className="form-control w-35vw" type="text" placeholder="Pergunta" value={item.title} onChange={handleChange} id={"title-" + item.id} />
            </div>

            <div className="field-filter-item">
                <label className="label-filter">Formato resposta</label>
                <br/>
                <select style={{width: '200px'}} value={item.answerType} onChange={handleChange} id={"answerType-" + item.id}>
                    {Object.entries(SURVEY_ANSWERS_TYPE_TEXT).map(([key, value]) => (
                        <option key={key} value={key}>
                        {value}
                        </option>
                    ))}
                </select>
            </div>

            {(item.answerType.toString() === SURVEY_ANSWERS_TYPE.CameraWithMultipleChoices.toString() || item.answerType.toString() === SURVEY_ANSWERS_TYPE.CameraWithMultipleChoicesPrice.toString()) && (
                <Fragment>
                    <div className="field-filter-item">
                        <div style={{maxWidth: '90px'}}>
                            <label className="label-filter">Resposta</label>
                            <label className="label-filter"> obrigatória</label>
                        </div>
                        <div style={{marginTop: '-25px', paddingLeft: '15px'}}>
                            <Switch
                                handleToggle={() => handleChange({target: {id: `required-${item.id}`, value: !item.required}})}
                                isOn={item.required === true}
                                isOnColor="#203ada"
                                isOffColor="#F9F9F9"
                                value={item.required}
                                id={"required-" + item.id}
                            />
                        </div>
                    </div>
                    <div className="field-filter-item">
                        <label className="label-filter">Opções de resposta</label>
                        <br/>
                        <textarea className="form-control" type="text" placeholder="Produto|EAN;Produto2|EAN..." value={item.answerOptions} onChange={handleChange} id={"answerOptions-" + item.id} />
                    </div>
                </Fragment>
            )}

            <div className="field-filter-item">
                <label className="label-filter">Palavras-chave IA</label>
                <br/>                
                <input className="form-control" type="text" placeholder="item1;item2;item3..." value={item.AIFilterKeywords} onChange={handleChange} id={"AIFilterKeywords-" + item.id} />
            </div>

            <div className="field-filter-item remove-item" onClick={() => removeItem(item.id)}>
                <Trash2/>
            </div>
        </div>
      );
}

export default Survey;